// Maps known FCM error codes to human-readable explanations for the
// Notification Logs detail view. Falls back to the raw code when unknown.
const FRIENDLY_FCM_ERRORS = {
  'messaging/registration-token-not-registered': 'Device token no longer valid',
  'messaging/invalid-registration-token': 'Invalid device token',
  'messaging/invalid-argument': 'Invalid message payload',
  'messaging/mismatched-credential': 'Token does not match this project',
  'messaging/authentication-error': 'FCM authentication error',
  'messaging/server-unavailable': 'FCM temporarily unavailable',
  'messaging/internal-error': 'FCM internal error',
  'messaging/message-rate-exceeded': 'Message rate exceeded',
  'messaging/quota-exceeded': 'Sending quota exceeded',
  'messaging/third-party-auth-error': 'APNs/web push credential error'
}

export const friendlyFcmError = (code) => {
  if (!code) return ''
  return FRIENDLY_FCM_ERRORS[code] || code
}

export default friendlyFcmError
